import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Modal from '../component/Modal';
import { Footer } from '../component/Footer';

const LandingPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <div className="min-h-screen bg-[#FFFDE1] font-sans text-zinc-900">
      {/* Navigation */}
      <nav className="flex items-center justify-between px-16 py-8 max-w-8xl mx-auto">
        <Link to={'/'} className="text-2xl font-bold tracking-tighter text-[#ef3a5d]">
        <img src='icon.png' style={{ width: 90, borderRadius: 12 }} alt='logo' />
          {/* DISCOWNTY<span className="text-zinc-400 text-xs ml-2 tracking-widest font-mono">V.1</span> */}
        </Link>
        <Link target='blank' to="https://partner.discownty.com"
        
        className="bg-black text-white px-6 py-2 rounded-full text-[10px] font-bold uppercase tracking-widest active:scale-95 transition-transform">
          Partner Login
        </Link>
      </nav>

      {/* Hero Section */}
         <section className="px-16 pt-16 pb-24 max-w-9xl mx-auto mt-20">
  <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
    {/* Left Content */}
    <div className="flex-1 text-center lg:text-left">
      <div className="inline-block px-4 py-1 border border-[#ef3a5d]/20 rounded-full text-[#ef3a5d] text-[10px] font-bold uppercase tracking-[0.3em] mb-6">
        Eat. Earn. Repeat.
      </div>
      <h1 className="text-5xl md:text-7xl font-bold tracking-tight mb-8 leading-[0.9]">
        YOUR LOYALTY <br />
        <span className="text-[#ef3a5d]">ACTUALLY PAYS.</span>
      </h1>
      <p className="text-zinc-600 max-w-xl lg:max-w-none mb-10 text-lg leading-relaxed">
        Join reward chains at your favorite restaurants and watch your <br className="hidden sm:block" />
        "Savings Pool" grow with every bite.
      </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full max-w-[500px] lg:justify-start">
  
  {/* Top Row / First Column */}
  <button 
    onClick={() => setIsModalOpen(true)} 
    className="w-full bg-[#ef3a5d] text-white py-4 rounded-2xl font-bold uppercase tracking-tight shadow-lg shadow-red-100 active:scale-95 transition-all hover:bg-[#d63350] text-center text-sm"
  >
    BECOME A PARTNER
  </button>

  <Link 
    to={'/partner-restaurants'} 
    className="w-full bg-[#ef3a5d] text-white py-4 rounded-2xl font-bold uppercase tracking-tight shadow-lg shadow-red-100 active:scale-95 transition-all hover:bg-[#d63350] text-center text-sm flex items-center justify-center"
  >
    Find restaurants
  </Link>

  {/* Bottom Row / Second Column */}
  <Link 
    to={'https://apps.apple.com/pk/app/discownty/id6757960111'} 
    className="w-full"
  >
    <img src='/appstore.png' className="w-full h-auto object-contain" alt="App Store" />
  </Link>

  <Link 
    to={'https://play.google.com/store/apps/details?id=com.hammadrao.MyApp'} 
    className="w-full"
  >
    <img src='/googleplay.png' className="w-full h-auto object-contain" alt="Google Play" />
  </Link>
  
</div>
    </div>

    {/* Right Video */}
   <div className="hidden lg:flex flex-1 items-center justify-end">
  <video 
    autoPlay 
    muted 
    playsInline
    width="800"
    height="800"
    className="object-contain"
    onTimeUpdate={(e) => {
      const video = e.target;
      // Added the !video.paused check to stop the CPU spike
      if (video.currentTime >= 3 && !video.paused) {
        video.pause();
        video.currentTime = 3; 
      }
    }}
  >
    <source src="/logo_vid.mp4" type="video/mp4" />
    {/* Your browser does not support the video tag. */}
  </video>
</div>
  </div>
</section>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        
  <div className="max-w-7xl mx-auto bg-zinc-900 rounded-[3rem] p-12 md:p-20 relative overflow-hidden shadow-2xl">
    {/* Decorative Glow */}
    <div className="absolute -left-20 -bottom-20 w-64 h-64 bg-[#ef3a5d] rounded-full blur-[120px] opacity-20"></div>
    
    <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-12">
      <div className="flex-1">
        <div className="inline-block px-4 py-1 bg-[#ef3a5d] rounded-full text-white text-[10px] font-bold uppercase tracking-[0.3em] mb-6">
          FOR RESTAURANT OWNERS
        </div>
        <h2 className="text-4xl md:text-6xl font-bold tracking-tight mb-6 leading-[0.9] text-white">
          STOP LEAVING <br />
          <span className="text-[#ef3a5d]">MONEY ON THE TABLE.</span>
        </h2>
        <p className="text-zinc-400 text-xl max-w-xl leading-relaxed">
          Boost your daily sales by gamifying loyalty. We don't just "track points"—we drive high-frequency visits and massive repeat spending that spikes your bottom line.
        </p>
        <div className="mt-8 flex items-center gap-6">
          <div>
            <p className="text-2xl font-bold text-white">3.5x</p>
            <p className="text-zinc-500 text-[10px] uppercase font-bold tracking-widest">Visit Frequency</p>
          </div>
          <div className="w-px h-10 bg-zinc-800"></div>
          <div>
            <p className="text-2xl font-bold text-white">60%+</p>
            <p className="text-zinc-500 text-[10px] uppercase font-bold tracking-widest">Increased Customer Retention</p>
          </div>
        </div>
      </div>

      <div className="flex-shrink-0 w-full md:w-auto">
        <Link 
          target="_blank"
          to='https://partner.discownty.com/form'
          // to="https://wa.me/923293433439"
          className="inline-block w-full md:w-auto bg-[#ef3a5d] text-white px-12 py-7 rounded-2xl font-bold uppercase tracking-[0.2em] text-center shadow-2xl shadow-[#ef3a5d]/20 active:scale-95 transition-all hover:bg-[#d63350] hover:-translate-y-1"
        >
          Become a partner
        </Link>
      </div>
    </div>
  </div>
      </Modal>

      {/* Customer Journey - Three Steps */}
      <section className="px-6 py-20 bg-white  shadow-sm  mb-20">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
            <div className="space-y-4">
              <div className="text-4xl">📱</div>
              <h3 className="text-xl font-bold uppercase tracking-tighter">1. Check-in</h3>
              <p className="text-zinc-500 text-sm leading-relaxed">
                Give your CustomerID at the counter after bill.
              </p>
            </div>
            <div className="space-y-4">
              <div className="text-4xl">💰</div>
              <h3 className="text-xl font-bold uppercase tracking-tighter">2. Build the Pool</h3>
              <p className="text-zinc-500 text-sm leading-relaxed">
                Every meal contributes to your reward pool. Discownty tracks your "chained" discounts automatically.
              </p>
            </div>
            <div className="space-y-4">
              <div className="text-4xl">🎁</div>
              <h3 className="text-xl font-bold uppercase tracking-tighter">3. Feast for Free</h3>
              <p className="text-zinc-500 text-sm leading-relaxed">
                On your milestone visit, the entire accumulated pool is deducted from your bill. Zero effort.
              </p>
            </div>
          </div>
      </section>

      {/* Live Reward Preview Component */}
      <section className="px-6 pb-32 max-w-4xl mx-auto">
        <div className="bg-zinc-900 text-[#FFFDE1] p-8 md:p-12 rounded-[2.5rem] relative overflow-hidden shadow-2xl">
          <div className="relative z-10">
            <label className="text-[10px] font-bold uppercase tracking-[0.4em] text-[#ef3a5d]">Live Status</label>
            <h2 className="text-3xl font-bold mt-2 mb-8 uppercase tracking-tighter">Current Savings Pool</h2>
            
            <div className="flex items-end gap-2 mb-10">
              <span className="text-6xl font-bold italic underline decoration-[#ef3a5d]">Rs 2,450</span>
              <span className="text-zinc-500 mb-2 font-mono">READY TO REDEEM</span>
            </div>

            <div className="grid grid-cols-6 gap-2">
              {[1, 2, 3, 4, 5].map((i) => (
                <div key={i} className="h-12 bg-white/10 rounded-lg flex items-center justify-center border border-white/5 font-bold">
                  {i}
                </div>
              ))}
              <div className="h-12 bg-[#ef3a5d] rounded-lg flex items-center justify-center animate-pulse">
                🌟
              </div>
            </div>
            <p className="text-zinc-500 text-[10px] uppercase tracking-widest mt-6 font-bold">
              Next Meal is on the house (or heavily discounted)
            </p>
          </div>
          
          {/* Decorative Background Element */}
          <div className="absolute -right-20 -top-20 w-64 h-64 bg-[#ef3a5d] rounded-full blur-[100px] opacity-20"></div>
        </div>
      </section>

      {/* Footer */}
     {/* Footer */}
      <Footer/>
    </div>
  );
};

export default LandingPage;